import { useEffect, useState } from 'react'
import classnames from 'classnames/bind'
import { useWindowWidth } from '@react-hook/window-size'

// Components
import Image from '@/components/common/Image'

// Constants
import { STORAGE_DATA } from '@/constants/storageData'

// Methods
import { readEcid } from '@/methods/lineshop/trackLineShopEvent'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// 螢幕寬度小於此值顯示手機尺寸圖，否則顯示 PC 尺寸圖
const MOBILE_BREAKPOINT = 1080

const PC_IMAGE = '/images/line-shop-reminder-pc.png'
const MOBILE_IMAGE = '/images/line-shop-reminder-mobile.png'

type LineShopReminderProps = {
  // 來源 URL 是否帶有 ecid
  hasEcid: boolean
}

const LineShopReminder = (props: LineShopReminderProps) => {
  const { hasEcid } = props

  const [isOpen, setIsOpen] = useState(false)
  const windowWidth = useWindowWidth()
  const isMobile = windowWidth > 0 && windowWidth < MOBILE_BREAKPOINT

  useEffect(() => {
    if (typeof window === 'undefined') return

    // ecid 來源：URL query，或已存於 cookie 且未過期（readEcid 會驗證效期）
    const hasEcidValue = hasEcid || !!readEcid()
    if (!hasEcidValue) return

    // 已讀紀錄存在 sessionStorage：僅在該頁籤開啟期間有效，關閉頁籤即清除，重開又會顯示
    const hasRead = window.sessionStorage.getItem(STORAGE_DATA.LINE_SHOP_REMINDER_READ)
    if (!hasRead) {
      setIsOpen(true)
    }
  }, [hasEcid])

  const handleClose = () => {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(STORAGE_DATA.LINE_SHOP_REMINDER_READ, '1')
    }
    setIsOpen(false)
  }

  if (!isOpen) return null

  return (
    // 整張圖 + 外圍遮罩皆可點擊關閉（「我知道了」按鈕已畫在圖片內）
    <div className={cx('reminder')} onClick={handleClose}>
      <div className={cx('reminder__image', { 'reminder__image--mobile': isMobile })}>
        <Image src={isMobile ? MOBILE_IMAGE : PC_IMAGE} alt='LINE 購物回饋重要提醒' fill priority sizes={isMobile ? '90vw' : '720px'} />
      </div>
    </div>
  )
}

export default LineShopReminder
